var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mi-progress-linear"},[_c('LoaderCard',{staticClass:"noShadow"}),_c('v-progress-linear',{attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }